import TableHead from '@layouts/layout-table/layout-table-head';
import TableRow from '@layouts/layout-table/layout-table-row';
import Checkbox from '@ui/checkbox/checkbox';
import SortButton from '@ui/buttons/sort-button/sort-button';
import Container from '@ui/container/container';
import { ICONS } from '@ui/icons/types';
import type { ColumnDefinition } from './profile-column-definitions';
import { getColumnSortDirection } from '../../utils';

interface ProfileTableHeadProps {
  visibleColumns: ColumnDefinition[];
  allDisplayedSelected: boolean;
  someDisplayedSelected: boolean;
  onSelectAll: () => void;
  currentSort: string | undefined;
  currentSortDirection: 'asc' | 'desc' | undefined;
  onSort: (sortKey: string) => () => void;
  /** When true, the sticky header background is transparent (loading state fade). */
  loading?: boolean;
}

const ProfileTableHead = ({
  visibleColumns,
  allDisplayedSelected,
  someDisplayedSelected,
  onSelectAll,
  currentSort,
  currentSortDirection,
  onSort,
  loading,
}: ProfileTableHeadProps) => (
  <TableHead
    style={{
      position: 'sticky',
      top: 0,
      backgroundColor: loading ? undefined : 'var(--gray-1000)',
      zIndex: 2,
      borderTop: 'none',
    }}
  >
    <TableRow>
      <th style={{ width: 64, minWidth: 64 }}>
        <Container className="padding-h-32">
          <Checkbox
            value="select-all"
            checked={allDisplayedSelected}
            partial={someDisplayedSelected}
            onChange={onSelectAll}
            size={16}
            selectedIconName={ICONS.ROUND_CHECKBOX_SELECTED}
            unselectedIconName={ICONS.ROUND_CHECKBOX_UNSELECTED}
          />
        </Container>
      </th>
      {visibleColumns.map(({ id, label, sortKey, columnWidth }) => (
        <th key={id} style={{ width: columnWidth, minWidth: columnWidth }}>
          <div className="flex ai-center gap-4">
            <span>{label}</span>
            {sortKey && (
              <SortButton
                onClick={onSort(sortKey)}
                sortDirection={getColumnSortDirection(sortKey, currentSort ?? '', currentSortDirection ?? '')}
              />
            )}
          </div>
        </th>
      ))}
      <th />
    </TableRow>
  </TableHead>
);

export default ProfileTableHead;
